import type { FC } from 'react';
import { useMeasureElement } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElement';
import BaseList from '../BaseList';
import ExclusiveListItem from '../../items/ExclusiveListItem';
import { Props } from '../../StudioDeviationList';
import { StudioDeviationListContext } from '../../context';

import s from './ExclusiveDeviationList.scss';

const ExclusiveDeviationList: FC<Props> = ({
  deviations,
  selectProps,
}) => {
  const { ref: actionsColRef, dimensions: actionsDimensions } =
    useMeasureElement({
      throttle: 250,
      throttleOptions: { trailing: true },
    });
  return (
    <StudioDeviationListContext.Provider
      value={{
        actionsColRef,
        actionsColWidth:
          actionsDimensions.width && Math.floor(actionsDimensions.width),
      }}
    >
      <BaseList
        className={s['list']}
        results={deviations}
        renderItem={(deviation, idx) => (
          <ExclusiveListItem
            key={deviation.deviationId}
            deviation={deviation}
            offset={idx}
            selected={selectProps.selected}
            onSelect={selectProps.onSelect}
          />
        )}
      />
    </StudioDeviationListContext.Provider>
  );
};
ExclusiveDeviationList.displayName = 'ExclusiveDeviationList';

export default ExclusiveDeviationList;
